/* eslint-disable camelcase */
import { storage } from '@utils/session-storage'

export default function analyticImpressions(object_list, item_list_id, item_list_name) {
  // if (!window.is_analytic_enabled) return
  const category_view = storage.getItem('category_view')
  if (category_view && category_view.toString() === item_list_id.toString()) return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      item_list_id,
      item_list_name,
      items: object_list,
    },
  })
  storage.setItem('category_view', item_list_id)
}

// const threshold = 0.7
// const options = {
//   root: null,
//   rootMargin: '0px',
//   threshold,
// }
// export const analyticImpressionHandler = (selector, item_list_id, item_list_name) => {
//   const targets = [...document.getElementsByClassName(selector)]

//   function analyticScroll(elements) {
//     const arr = []

//     elements.forEach(entry => {
//       if (entry.isIntersecting) {
//         const { item_id, item_name, price, item_brand, item_category } = entry.target.dataset
//         const obj = {
//           item_id, item_name, price, item_brand, item_category, item_list_name,
//         }
//         arr.push(obj)
//       }
//     })
//     if (arr.length) analyticImpressions(arr, item_list_id, item_list_name)
//   }

//   const observer = new IntersectionObserver(analyticScroll, options)
//   const ar = [].slice.call(targets)

//   ar.forEach(target => {
//     observer.observe(target)
//   })
// }
export const analyticImpressionHandler = (selector, item_list_id, item_list_name) => {
  const targets = [...document.getElementsByClassName(selector)]

  const arr = []
  targets.forEach(entry => {
    const { item_id, item_name, price, item_brand, item_category } = entry.dataset
    const obj = {
      item_id, item_name, price, item_brand, item_category, item_list_name,
    }
    arr.push(obj)
  })
  if (arr.length) analyticImpressions(arr, item_list_id, item_list_name)
}
